import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ERROR_UPDATE } from "../store/slices";

export const GlobalErrorModal = () => {
  const dispatch = useDispatch();
  const { error, message } = useSelector((state: any) => state.error);

  const handleClose = () => {
    dispatch(
      ERROR_UPDATE({
        data: {
          error: false,
          message: "",
          isLoading: false,
          success: false,
        },
      }),
    );
  };

  return (
    <Modal className="modal show" show={error} onHide={handleClose}>
      <Modal.Header closeButton={false}>
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} variant="secondary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
